import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Pagination } from 'src/app/tarefas/interface/tasks.interface';

@Component({
  selector: 'app-paginacao-tarefas',
  standalone: true,
  templateUrl: './paginacao-tarefas.component.html',
  styleUrls: ['./paginacao-tarefas.component.scss'],
  imports: [CommonModule],
})
export class PaginacaoTarefasComponent implements OnInit {
  @Input() paginacao: Pagination;
  @Output() paginaMudada = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  mudarPagina(direcao: number) {
    const novaPagina = this.paginacao.page + direcao;
    if (
      novaPagina >= this.paginacao.pageFirst &&
      novaPagina <= this.paginacao.pageLast
    ) {
      this.paginaMudada.emit(novaPagina);
    }
  }

  get paginasVisiveis(): number[] {
    const total = this.paginacao.pageLast;
    const atual = this.paginacao.page;
    const max = 15;
    let start = 1;
    let end = total;
    if (total > max) {
      const meio = Math.floor(max / 2);
      if (atual <= meio) {
        start = 1;
        end = max;
      } else if (atual + meio >= total) {
        start = total - max + 1;
        end = total;
      } else {
        start = atual - meio;
        end = atual + meio;
      }
    }
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }
}
